import { Component, Inject, OnInit } from '@angular/core';

import { CaseModel } from '@app/ps/models/case.model';
import { ConfirmationConfigData, DialogConfig, DialogConfigData } from '@app/common/models/dialog-config';
import { defaultLegalException } from '@app/ps/cases/components/form-contracts-register/contracts-register-legal-exceptions';
import { DialogRef } from '@app/common/services/dialog-ref';
import { DialogService } from '@app/common/services/dialog.service';
import { Restangular } from 'ngx-restangular';
import { APP_BRAND } from '@app/common/services/config.service';

@Component({
  selector: 'form-contracts-register-dialog',
  templateUrl: './form-contracts-register-dialog.component.html',
  styleUrls: ['./form-contracts-register-dialog.component.scss'],
})
export class FormContractsRegisterDialogComponent implements OnInit {
  readonly PUBLISH_CONFIRM_MSG = 'Skutečně chcete tuto smlouvu zveřejnit v registru smluv? Její hodnota nepřesahuje 50000,- Kč.';
  readonly NOT_PUBLISH_CONFIRM_MSG = 'Skutečně nechcete tuto smlouvu zveřejnit v registru smluv? Její hodnota přesahuje 50000,- Kč.';

  initialCaseObject: CaseModel;
  caseObject: CaseModel;
  publishFormVisible = false;
  doNotPublishFormVisible = false;

  constructor(
    private restangular: Restangular,
    private config: DialogConfig,
    private dialog: DialogRef,
    private dialogService: DialogService,
    @Inject(APP_BRAND) public APP_BRAND: any,
  ) {  }

  ngOnInit() {
    this.caseObject = (<DialogConfigData>this.config.data).caseObject;
    this.initialCaseObject = {...this.caseObject};

    this.isValidForNotPublishing = this.isValidForNotPublishing.bind(this);
    this.isValidForPublishing = this.isValidForPublishing.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.onExceptionSelected = this.onExceptionSelected.bind(this);
    this.onRenderOrSubmitDoNotPublishForm = this.onRenderOrSubmitDoNotPublishForm.bind(this);
    this.onRenderPublishForm = this.onRenderPublishForm.bind(this);
    this.onSend = this.onSend.bind(this);
    this.onPublishDirectly = this.onPublishDirectly.bind(this);
  }

  onExceptionSelected(value: string) {
    this.caseObject.contractRegisterPublicationException = value;
  }

  onCancel() {
    this.publishFormVisible = false;
    this.doNotPublishFormVisible = false;
    this.caseObject = {...this.initialCaseObject};
  }

  onPublishDirectly() {
    let promise = new Promise((resolve) => {
      resolve(true);
    });

    if (!this.caseObject.contractRegisterPublicationNecessary) {
      promise = this.dialogService.confirmDialogPromise(this.PUBLISH_CONFIRM_MSG);
    }

    return promise.then(result => {
      if (result === true) {
        return this.onSend();
      } else {
        this.onCancel();
      }
    });
  }

  onRenderPublishForm() {
    let promise = new Promise((resolve) => {
      resolve(true);
    });

    if (!this.caseObject.contractRegisterPublicationNecessary) {
      promise = this.dialogService.confirmDialogPromise(this.PUBLISH_CONFIRM_MSG);
    }

    return promise.then(result => {
      if (result === true) {
        this.publishFormVisible = true;
      } else {
        this.onCancel();
      }
    });
  }

  onRenderOrSubmitDoNotPublishForm() {
    let promise = new Promise((resolve) => {
      resolve(true);
    });

    if (this.caseObject.contractRegisterPublicationNecessary) {
      promise = this.dialogService.confirmDialogPromise(this.NOT_PUBLISH_CONFIRM_MSG);
    }

    return promise.then(val => {
      if (val === true) {
        if (this.caseObject.contractRegisterPublicationNecessary) {
          this.doNotPublishFormVisible = !this.doNotPublishFormVisible;
        } else {
          this.caseObject.contractRegisterPublicationException = defaultLegalException;
          return this.onSend();
        }
      }
    });
  }

  isValidForPublishing(): boolean {
    return !!(this.caseObject.contractRegisterPublicationDate
      && this.caseObject.contractRegisterPublicationContractId
      && this.caseObject.contractRegisterPublicationVersionId);
  }

  isValidForNotPublishing(): boolean {
    return !!this.caseObject.contractRegisterPublicationException;
  }

  async onSend(): Promise<CaseModel> {
    this.caseObject.contractRegisterPublicationDate = this.caseObject.contractRegisterPublicationDate || new Date();
    const result: CaseModel = await this.restangular
      .one('cases', this.caseObject.id)
      .customPUT(this.caseObject, 'contract-register-publication')
      .toPromise();

    this.dialog.close(result);
    return result;
  }
}

